import { Preferences } from '@capacitor/preferences';

// Guardamos en Preferences sólo datos no sensibles. Los tokens y roles se mantienen
// en sessionStorage por seguridad. Aun así exponemos un helper `getAuthToken()`
// que devuelve primero el token en sessionStorage (si existe) y como fallback
// intenta leerlo de Preferences para compatibilidad con instalaciones previas.
const USER_KEYS = ['user_name', 'selectedLocale'];

export async function initPreferencesToSession() {
  try {
    for (const key of USER_KEYS) {
      const { value } = await Preferences.get({ key });
      if (value != null && value !== '') sessionStorage.setItem(key, value);
      else sessionStorage.removeItem(key);
    }
  } catch (e) {
    console.warn('initPreferencesToSession failed', e);
  }
}

export async function setUserPrefs({ auth_token, user_name, user_role, user_id }) {
  try {
    // Mantener la misma firma por compatibilidad, pero sólo persistir datos no sensibles
    if (user_name != null) await Preferences.set({ key: 'user_name', value: String(user_name) });
  } catch (e) {
    console.warn('setUserPrefs error', e);
  }
}

export async function removeUserPrefs() {
  try {
    for (const key of USER_KEYS) {
      await Preferences.remove({ key });
    }
  } catch (e) {
    console.warn('removeUserPrefs error', e);
  }
}

export async function setLocalePref(locale) {
  try {
    await Preferences.set({ key: 'selectedLocale', value: String(locale) });
  } catch (e) {
    console.warn('setLocalePref error', e);
  }
}

export async function getAuthToken() {
  try {
    // Preferir token en sessionStorage (no persistente). Esto permite mantener
    // la política de seguridad mientras ofrecemos compatibilidad.
    try {
      const t = sessionStorage.getItem('auth_token');
      if (t) return String(t);
    } catch (e) {
      // sessionStorage puede fallar en entornos restringidos.
    }

    // Fallback: intentar leer de Preferences por compatibilidad con instalaciones
    // antiguas (si existiera).
    const { value } = await Preferences.get({ key: 'auth_token' });
    return value ?? null;
  } catch (e) {
    console.warn('getAuthToken error', e);
    return null;
  }
}
